const JdStepOne = () => import('@/views/purchaseProcess/commonMode/jd/stepOne')
const JdStepTwo = () => import('@/views/purchaseProcess/commonMode/jd/stepTwo')
const JdStepThree = () => import('@/views/purchaseProcess/commonMode/jd/stepThree')
const JdQuestionOne = () => import('@/views/purchaseProcess/commonMode/jd/quesAndAnswers/QuestionOne')
const JdQuestionTwo = () => import('@/views/purchaseProcess/commonMode/jd/quesAndAnswers/QuestionTwo')
const JdQuestionThree = () => import('@/views/purchaseProcess/commonMode/jd/quesAndAnswers/QuestionThree')

export default [
  {
    name: 'jdStepOne',
    path: '/jdStepOne',
    component: JdStepOne,
    meta: {
      title: '第一步'
    }
  },
  {
    name: 'jdStepTwo',
    path: '/jdStepTwo',
    component: JdStepTwo,
    meta: {
      title: '第二步'
    }
  },
  {
    name: 'jdStepThree',
    path: '/jdStepThree',
    component: JdStepThree,
    meta: {
      title: '第三步'
    }
  },
  // 拼多多问题回答
  {
    name: 'jdQuestionOne',
    path: '/jdQuestionOne',
    component: JdQuestionOne
  },
  {
    name: 'jdQuestionTwo',
    path: '/jdQuestionTwo',
    component: JdQuestionTwo
  },
  {
    name: 'jdQuestionThree',
    path: '/jdQuestionThree',
    component: JdQuestionThree
  }
]
